import React, { useEffect, useState } from "react";
import "./YouTubeGallery.css";

const API_KEY    = "AIzaSyBr1pPUSDpHLebS35GLSEb0FZFVAAu-xOA";
const CHANNEL_ID = "UCa5UWRmFQNDnE07oOqcS2Wg";
const CHANNEL_URL = `https://www.youtube.com/channel/${CHANNEL_ID}`;

interface Video {
  id: string;
  title: string;
  thumbnail: string;
}

const YouTubeGallery: React.FC = () => {
  const [videos, setVideos]   = useState<Video[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(false);
  let i : number;

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const channelRes = await fetch(
          `https://www.googleapis.com/youtube/v3/channels?part=contentDetails&id=${CHANNEL_ID}&key=${API_KEY}`
        );
        const channelData = await channelRes.json();
        const uploadsId = channelData.items?.[0]?.contentDetails?.relatedPlaylists?.uploads;
        if (!uploadsId) throw new Error();

        const playlistRes = await fetch(
          `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${uploadsId}&maxResults=4&key=${API_KEY}`
        );
        const playlistData = await playlistRes.json();
        setVideos(
          playlistData.items.map((item: any) => ({
            id: item.snippet.resourceId.videoId,
            title: item.snippet.title,
            thumbnail: item.snippet.thumbnails.medium.url,
          }))
        );
      } catch {
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchVideos();
  }, []);

  if (error) return null;

  return (
    <section className="yt-section">
      <div className="yt-section__inner">
        <h2>Ma chaîne YouTube</h2>
        {loading ? (
          <div className="yt-loading">Chargement des vidéos…</div>
        ) : (
          <div className="yt-grid">
            <a className="yt-card yt-card--channel" href={CHANNEL_URL} target="_blank" rel="noopener noreferrer">
              <div className="yt-card__icon">▶</div>
              <p>Voir toutes mes vidéos</p>
            </a>
            {videos.map((v) => (
              <a
                key={v.id}
                className="yt-card"
                href={`https://www.youtube.com/watch?v=${v.id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={v.thumbnail} alt={v.title} className="yt-card__thumb" loading="lazy" />
                <p className="yt-card__title">{v.title}</p>
              </a>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default YouTubeGallery;
